import { removeKeysFromObj as e } from "./object.js";
//#region src/utils/storageManager.ts
function t(e) {
	return new r(localStorage, e);
}
function n(e) {
	return new r(sessionStorage, e);
}
var r = class {
	LOCAL_STORAGE_KEY;
	versionDelimiter = ".";
	storage;
	storageType;
	constructor(e, t) {
		this.LOCAL_STORAGE_KEY = t, this.storage = e, this.storageType = e === localStorage ? "local" : "session";
	}
	getFromStorage = (e) => {
		try {
			let t = this.storage.getItem(this.LOCAL_STORAGE_KEY);
			return t === null ? null : JSON.parse(t)[e];
		} catch (e) {
			return console.error(`getFromStorage, can't get data from ${this.storageType} storage: `, e.message), null;
		}
	};
	saveToStorage = (t, n) => {
		try {
			let r = this.storage.getItem(this.LOCAL_STORAGE_KEY), i = e(r === null ? {} : JSON.parse(r), this.generateOlderKeys(t));
			return i[t] = n, this.storage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(i)), !0;
		} catch (e) {
			return console.error(`saveToStorage, can't save data to ${this.storageType} storage: `, e.message), !1;
		}
	};
	removeUnitFromStorage = (e) => {
		try {
			let t = this.storage.getItem(this.LOCAL_STORAGE_KEY), n = t === null ? {} : JSON.parse(t);
			delete n[e], this.storage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(n));
		} catch (e) {
			console.error(`removeUnitFromStorage, can't remove data from ${this.storageType} storage: `, e.message);
		}
	};
	cleanObsoleteStorage = () => {
		try {
			let e = this.generateOlderKeys(this.LOCAL_STORAGE_KEY);
			for (let t of e) this.storage.removeItem(t);
		} catch (e) {
			console.error(`cleanObsoleteStorage, can't remove obsolete data from ${this.storageType} storage: `, e.message);
		}
	};
	generateOlderKeys = (e) => {
		let t = [], n = e.split(this.versionDelimiter), r = Number(n.find((e) => e[0] === "v" && isFinite(Number(e.slice(1))))?.slice(1));
		for (let n = 1; n < r; n++) e.indexOf(`.v${r}.`) !== -1 && t.push(e.replace(`.v${r}.`, `.v${n}.`));
		return t;
	};
};
//#endregion
export { r as StorageManager, t as createLocalStorageManager, n as createSessionStorageManager };
